export enum Billing {
  billingArea = 'V',
  roomCostCenter = 'R',
  workPlace = 'A',
  magentaOffice = 'M',
  access = 'Z',
}
